import axiosInstance from './axiosInstance.service';
import IUser from '@cc/shared-service/src/server/types/response/IUser';

/**
 * calls the api to authenticate the credentials
 * @param credentials
 */
export const authenticateUser = () => {
    return axiosInstance.post('authenticate-user');
}

export const persistCurrentUser = (user: IUser) => {
    return localStorage.setItem('current_user', JSON.stringify(user));
}

export const deletePersistedCurrentUser = () => {
    return localStorage.removeItem('current_user')
}

export const getCurrentUser = (): IUser | null => {
    if (localStorage.getItem('current_user')) {
        return JSON.parse(localStorage.getItem('current_user')!);
    } else {
        return null;
    }
}
